import * as t from "react";
import "react/jsx-runtime";
var r = t.createContext(void 0);
function i(e) {
  const o = t.useContext(r);
  return e || o || "ltr";
}
export {
  i as u
};
